export default __webpack_public_path__ + "../staticImages/glaeser_rose-260.png";